import { useI18n } from 'vue-i18n';

import countries from '@/data/insuretostudy/destination_countries.json';

export function useDataFormat() {
  let res = [];

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const transformArray = (arr) => {
    if (arr.length > 0) {
      arr.forEach((val) => {
        //ondersteuning voor het format label:value; label:value; label:value en value;value;value
        if (val !== '') {
          if (val.includes(':')) {
            let item = val.split(':');
            res.push({
              label: item[0],
              value: item[1],
            });
          } else {
            res.push({
              label: val,
              value: val,
            });
          }
        }
      });
    }
    return res;
  };

  const booleanToOkOrDash = (value) => {
    const { t } = useI18n();

    return value === 'true' ? t('general.yes') : '-';
  };

  const allInsuranceNamesFormat = (insuranceNames) => {
    if (insuranceNames.length === 1) {
      return insuranceNames[0];
    }

    let insuranceNamesString = insuranceNames.join(', ');
    const lastCommaIndex = insuranceNamesString.lastIndexOf(',');
    insuranceNamesString = `${insuranceNamesString.slice(0, lastCommaIndex)} en ${insuranceNamesString.slice(lastCommaIndex + 1)}`;

    return insuranceNamesString;
  };

  const getCountryLabelByValue = (value) => {
    const country = countries.find((country) => country.value === value);
    return country ? country.label : null;
  };

  const addDotAfterEachLetter = (input) => {
    return input ? input.replace(/([a-zA-Z])/g, '$1.') : '';
  };

  const removeDots = (input) => {
    return input ? input.replace(/\./g, '') : '';
  };

  return { capitalizeFirstLetter, transformArray, booleanToOkOrDash, allInsuranceNamesFormat, getCountryLabelByValue, addDotAfterEachLetter, removeDots };
}
